/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type FavoritesItemProvider_item = {
    readonly serviceId: string | null;
    readonly " $refType": "FavoritesItemProvider_item";
};
export type FavoritesItemProvider_item$data = FavoritesItemProvider_item;
export type FavoritesItemProvider_item$key = {
    readonly " $data"?: FavoritesItemProvider_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FavoritesItemProvider_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavoritesItemProvider_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a8934b824610d50aad3b8e9f4507330b';
export default node;
